import { render, staticRenderFns } from "./BroadcastItem.vue?vue&type=template&id=31f86b39&"
import script from "./BroadcastItem.vue?vue&type=script&lang=js&"
export * from "./BroadcastItem.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastItem.vue?vue&type=style&index=0&id=31f86b39&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports